var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "plan-tooltip",
        { attrs: { page: _vm.page, placement: _vm.$attrs.placement } },
        [
          _c(
            "simple-button",
            _vm._b(
              {
                attrs: { disabled: _vm.$attrs.disabled || _vm.usageRestricted },
                on: {
                  click: _vm.handleClick,
                  finish: function ($event) {
                    return _vm.$emit("finish", $event)
                  },
                },
              },
              "simple-button",
              _vm.$attrs,
              false
            ),
            [_vm._t("default")],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }